import { render, staticRenderFns } from "./ClickBaseButton.vue?vue&type=template&id=568d7143"
import script from "./ClickBaseButton.vue?vue&type=script&lang=js"
export * from "./ClickBaseButton.vue?vue&type=script&lang=js"
import style0 from "./ClickBaseButton.vue?vue&type=style&index=0&id=568d7143&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports